module.exports = __webpack_public_path__ + "static/13-0bead898e3a5206faba19eedcac68ac6.wav";